// React Imports
import {useState, useEffect} from "react";
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
} from '@mui/x-data-grid';
import {DataGridPro} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import {
    Drawer,
    Stack,
} from "@mui/material";
import Typography from "@mui/material/Typography";

// App Imports
import {getFinancialObligationData} from "../../../ExternalData/Financial/FinancialClient";
import {changeObligationHierarchy} from "../obligationHierarchySlice";


// main function
export default function WorkIssuanceObligationFinancialGrid() {


    // ****************** BEGIN STATES ****************************

    const [financialData, setFinancialData] = useState([]);
    const [drawerOpen, setDrawerOpen] = useState([true]);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorCdpvId = useSelector((state) => state.obligationHierarchySlc.value.cdpvId);
    const selectorDataPointName = useSelector((state) => state.obligationHierarchySlc.value.dataPointName);
    const selectorDisplayAmount = useSelector((state) => state.obligationHierarchySlc.value.displayValue);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        let isMounted = true;
        console.log("on the receiving end, here's my selectorCdpvId :",selectorCdpvId );
        getFinancialObligationData(selectorCdpvId)

            .then(data => {
                if (isMounted) {
                    setFinancialData(data)
                }
            });
        return () => {
            isMounted = false;
        };
    }, [useSelector((state) => state.obligationHierarchySlc.value.financialGridOpen)===true]);

    // ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    const handleClose = () => {
        dispatchData(changeObligationHierarchy({financialGridOpen: false}));
        setDrawerOpen(false);
    };


    function closeFinancialDataDrawer() {
        dispatchData(changeObligationHierarchy({financialGridOpen: false}));
        setDrawerOpen(false);
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN COLUMNS ***************************

    const columns = columnsFinancialData => [

        {    field: 'propertyId',
            headerName: 'Property',
            description: '',
            sortable: false,
            width: 150,
            hide: false,
        },
           {    field: 'account',
            headerName: 'Account',
            description: '',
            sortable: false,
            width: 150,
            hide: false,
        },
        {    field: 'amount',
            headerName: 'Amount',
            description: '',
            sortable: false,
            width: 100,
            hide: true,
        },
        {    field: 'displayAmount',
            headerName: 'Amount',
            description: '',
            sortable: false,
            width: 130,
            hide: false,
            align: "right"
        },
        {    field: 'amountType',
            headerName: 'Currency',
            description: '',
            sortable: false,
            width: 80,
            hide: false,
        },
        {    field: 'financialMarket',
            headerName: 'Market',
            description: '',
            sortable: false,
            width: 200,
            hide: false,
        },
        {    field: 'territory',
            headerName: 'Territory',
            description: '',
            sortable: false,
            width: 80,
            hide: false,
        },
        {    field: 'periodEndDate',
            headerName: 'Period End',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },
        {    field: 'adjustFrom',
            headerName: 'Adjusted From',
            description: '',
            sortable: false,
            width: 120,
            hide: false,
        },
        {    field: 'adjustTo',
            headerName: 'Adjusted To',
            description: '',
            sortable: false,
            width: 120,
            hide: false,
        },
        {    field: 'id',
            headerName: 'ID',
            description: '',
            sortable: false,
            width: 100,
            hide: false,
        },

    ];

    // *************** END COLUMNS *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <GridToolbarColumnsButton />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

    // ****************** END TOOLBAR ****************************


    // ****************** BEGIN RETURN ****************************

    return (
            <div>
                <Drawer sx={{height: "100%", width: 1600}}
                        anchor='right'
                        open={useSelector((state) => state.obligationHierarchySlc.value.financialGridOpen)}
                        onClose={closeFinancialDataDrawer}
                >
                    <Box>
                        <br/>
                        <h2 style={{paddingLeft: 19, cursor: 'pointer'}} onClick={() => handleClose()}>Financial Data</h2>
                        <br/>
                        < Stack direction="row" spacing={2}>
                            <Typography sx={{fontWeight: 'bold', pl: 3}}>Data Point</Typography>
                            <Typography>{selectorDataPointName}: {selectorDisplayAmount}</Typography>
                        </Stack>
                        <Box sx={{pl: 2}}>
                            <DataGridPro

                            style={{height: 600, width: 1250}}
                            aria-label={"FinancialDataDrawerGrid"}
                            rows={financialData}
                            disableDensitySelector={true}
                            disableColumnSelector={true}

                            columns={columns(financialData)}
                            density={"compact"}
                            pageSize={20}
                            rowsPerPageOptions={[20]}

                            rowThreshold={0}

                            components={{
                                Toolbar: CustomToolbar,
                            }}

                        />
                        </Box>
                        </Box>
                </Drawer>
            </div>
);

    // ****************** END RETURN ****************************


}



